import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { useEffect, useState } from "react";
import { isPassedDue } from "./App";
import { readOnlyPreview } from "./leagueStore";

/**
 * Popup shown to the weekly challenge recipient after submitting picks or rankings.
 * preview=true: admin demo — buttons do not write to Firestore.
 */
export default function ChallengeOfferModal({
  show,
  onHide,
  challenge,
  onAccept,
  onDecline,
  preview = false,
}) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [, tick] = useState(0);
  useEffect(() => { setError(""); const timer = setInterval(() => tick(t => t + 1), 1000); return () => clearInterval(timer); }, [show]);
  if (!challenge) return null;
  const closed = isPassedDue(challenge.Week);
  async function decide(action) {
    setBusy(true); setError("");
    try { await action(); } catch (e) { setError(e.message || "Could not save your decision. Please try again."); }
    finally { setBusy(false); }
  }

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="challenge-offer">
      <Modal.Header closeButton>
        <Modal.Title>Weekly FAAB Challenge</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger" role="alert">{error}</Alert>}
        {closed && !preview && <Alert variant="info">The Thursday 7:30 p.m. CT deadline has passed. Decisions are closed.</Alert>}
        {preview && (
          <Alert variant="info" style={{ textAlign: "left", fontSize: "0.9rem" }}>
            Preview only — this is what the recipient sees after they submit
            picks or rankings. Nothing is saved when you click the buttons below.
          </Alert>
        )}
        <div className="challenge-offer-top"><span className="personal-eyebrow">Week {challenge.Week} · Your invitation</span><span className="challenge-reward">${challenge.Faab} <small>FAAB</small></span></div>
        <h3>{challenge.RecipientName}</h3><p className="challenge-task-copy">{challenge.Text}</p>
        <p className="stats-context">Accept by Thursday, 7:30 p.m. CT. Earn the reward if the commissioner marks your challenge achieved.</p>
      </Modal.Body>
      <Modal.Footer>
        {preview ? (
          <>
            <Button variant="secondary" disabled style={{ opacity: 0.85 }}>
              I'll sit this one out
            </Button>
            <Button variant="primary" disabled style={{ opacity: 0.85 }}>
              I accept
            </Button>
            <Button variant="outline-secondary" onClick={onHide}>
              Close preview
            </Button>
          </>
        ) : (
          <>
            <Button variant="secondary" disabled={closed || busy || readOnlyPreview} onClick={() => decide(onDecline)}>
              I'll sit this one out
            </Button>
            <Button variant="primary" disabled={closed || busy || readOnlyPreview} onClick={() => decide(onAccept)}>
              I accept
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}
